import * as path from "path";
import * as React from "react";
import { ListGroupItem, Media, Popover } from "react-bootstrap";
import { Provider } from "react-redux";
import { pathToFileURL } from "url";
import { nexusGames } from "../../../extensions/nexus_integration/util";
import { nexusGameId } from "../../../extensions/nexus_integration/util/convertGameId";
import { ComponentEx } from "../../../controls/ComponentEx";
import IconBar from "../../../controls/IconBar";
import OverlayTrigger from "../../../controls/OverlayTrigger";
import { IconButton } from "../../../controls/TooltipControls";
import opn from "../../../util/opn";
import GameInfoPopover from "./GameInfoPopover";
/**
 * thumbnail + controls for a single game mode within the game picker
 *
 * @class GameThumbnail
 */
class GameRow extends ComponentEx {
    mRef = null;
    render() {
        const { t, active, container, discovery, game, getBounds, onRefreshGameInfo, type, } = this.props;
        if (game === undefined) {
            return null;
        }
        let logoPath = game.extensionPath !== undefined && game.logo !== undefined
            ? path.join(game.extensionPath, game.logo)
            : game.imageURL;
        // For adaptor-registered games (no local logo), resolve a Nexus thumbnail
        if (logoPath == null) {
            const domain = nexusGameId(game);
            const numericId = domain != null
                ? nexusGames().find((g) => g.domain_name === domain)?.id
                : undefined;
            if (numericId !== undefined) {
                logoPath = `https://images.nexusmods.com/images/games/v2/${numericId}/thumbnail.jpg`;
            }
        }
        const location = discovery !== undefined && discovery.path !== undefined ? (React.createElement("a", { onClick: this.openLocation }, discovery.path)) : null;
        const classes = ["game-list-item"];
        if (active) {
            classes.push("game-list-selected");
        }
        if (discovery === undefined) {
            classes.push("game-list-undiscovered");
        }
        const gameInfoPopover = (React.createElement(Popover, { className: "popover-game-info", id: `popover-info-${game.id}` },
            React.createElement(Provider, { store: this.context.api.store },
                React.createElement(IconBar, { buttonType: "text", className: "buttons", collapse: false, filter: this.lowPriorityButtons, group: `game-${type}-buttons`, id: `game-thumbnail-${game.id}`, instanceId: game.id, orientation: "vertical", staticElements: [], t: t }),
                React.createElement(GameInfoPopover, { game: game, t: t, onChange: this.redraw, onRefreshGameInfo: onRefreshGameInfo }))));
        let imgurl = null;
        if (logoPath != null) {
            let protocol = null;
            try {
                protocol = new URL(logoPath)?.protocol;
            }
            catch {
                // not a URL, treat as file path
            }
            imgurl =
                protocol != null && protocol.startsWith("http")
                    ? logoPath
                    : pathToFileURL(logoPath).href;
        }
        return (React.createElement(ListGroupItem, { className: classes.join(" ") },
            React.createElement(Media, null,
                React.createElement(Media.Left, null,
                    React.createElement("div", { className: "game-thumbnail-container-list" },
                        React.createElement("img", { className: "game-thumbnail-img-list", src: imgurl }))),
                React.createElement(Media.Body, null,
                    React.createElement(Media.Heading, null, t(game.name.replace(/\t/g, " "))),
                    location !== null ? (React.createElement("p", null,
                        t("Location"),
                        ": ",
                        location)) : null),
                React.createElement(Media.Right, null,
                    React.createElement(OverlayTrigger, { container: container, getBounds: getBounds, orientation: "horizontal", overlay: gameInfoPopover, rootClose: true, shouldUpdatePosition: true, trigger: "click", triggerRef: this.setRef },
                        React.createElement(IconButton, { className: "btn-embed", icon: "game-menu", id: `btn-info-${game.id}`, tooltip: t("Show Details") })),
                    React.createElement(IconBar, { buttonType: "icon", className: "btngroup-game-list", clickAnywhere: true, collapse: false, filter: this.priorityButtons, group: `game-${type}-buttons`, instanceId: game.id, showAll: true, staticElements: [], t: t })))));
    }
    setRef = (ref) => {
        this.mRef = ref;
    };
    redraw = () => {
        if (this.mRef !== null) {
            this.mRef.hide();
            setTimeout(() => {
                if (this.mRef !== null) {
                    this.mRef.show();
                }
            }, 100);
        }
    };
    openLocation = () => {
        const { discovery } = this.props;
        opn(discovery.path).catch(() => null);
    };
    changeLocation = () => {
        this.props.onBrowseGameLocation(this.props.game.id);
    };
    priorityButtons = (action) => action.position < 100;
    lowPriorityButtons = (action) => action.position >= 100;
}
export default GameRow;
